import React from 'react';
import { Dialog } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { useTheme } from 'hooks';

interface Props {
  open: boolean;
  handleClose?: (event: any, reason: 'backdropClick' | 'escapeKeyDown') => void;
  body: React.ReactNode;
  backgroundColor?: string;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const CustomDialog = ({
  open,
  handleClose,
  body,
  backgroundColor,
  fullWidth,
  sx,
}: Props) => {
  const { palette } = useTheme();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      componentsProps={{
        backdrop: {
          style: {
            backgroundColor: backgroundColor || palette.backdrop.main,
          },
        },
      }}
      fullWidth={fullWidth}
      sx={sx}
    >
      {body}
    </Dialog>
  );
};

export default CustomDialog;
